import { StyleSheet } from 'aphrodite';
import { background, brandSecondary, navigation, titles } from '../../../../web/styles/colors';
import { CssSelectors } from '../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	changeButton: {
		alignItems: 'center',
		color: brandSecondary,
		display: 'flex',
		flexDirection: 'column',
		fontSize: 18,
		justifyContent: 'center',
		textAlign: 'center',
		...CssSelectors.allChildren(
			{
				marginTop: 13,
			},
			':not(:first-child)'
		),
	},
	container: {},
	header: {
		color: navigation,
		fontSize: 12,
		margin: '12px 0 6px 0',
	},
	info: {
		fontSize: 14,
	},
	inputRow: {
		alignItems: 'center',
		display: 'flex',
		flex: 1,
		flexDirection: 'row',
		margin: '12px 0',
		maxHeight: 35,
	},
	loading: {
		marginTop: 8,
	},
	textBox: {
		background,
		border: '1px solid #ccc',
		borderRadius: 3,
		boxSizing: 'border-box',
		color: titles,
		fontSize: 14,
		height: 30,
		marginRight: 8,
		padding: '5px 5px 5px 10px',
		width: '100%',
	},
});
